import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  IPaiyaTypeCategory,
  IPaiyaConfigCreationState,
  // IAddUpdatePaiyaPageState,
  IWarehouseCategory,
  IDeliveryDateCreationState,
  IAddUpdateDeliveryDatePageState,
  IPaiyaMOVGameStatusPayload,
} from "../../interfaces/Index";
import {
  fetchPaiyaTypeApiCall,
  createPaiyaStoreCsvApiCall,
  createPaiyaGiftCsvApiCall,
  createPaiyaMovGameStatusApiCall,
  fetchPaiyaConfigApiCall
} from "redux/sources/PaiyaSource";

// Init, success, failure state for delivery date warehouses
export const getPaiyaTypesInit = () => ({
  type: actionTypes.GET_PAIYA_TYPES_INIT,
});

export const getPaiyaTypesSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_PAIYA_TYPES_SUCCESS,
  payload,
});

export const getPaiyaTypesFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_PAIYA_TYPES_FAIL,
  error,
});

// Init, success, failure state for create paiya config store
export const createPaiyaStoreCsvInit = () => ({
  type: actionTypes.CREATE_PAIYA_STORE_CONFIG_INIT,
});

export const createPaiyaStoreCsvSuccess = () => ({
  type: actionTypes.CREATE_PAIYA_STORE_CONFIG_SUCCESS,
});

export const createPaiyaStoreCsvFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_PAIYA_STORE_CONFIG_FAIL,
  error,
});

// Init, success, failure state for create paiya config gift
export const createPaiyaGiftCsvInit = () => ({
  type: actionTypes.CREATE_PAIYA_GIFT_CONFIG_INIT,
});

export const createPaiyaGiftCsvSuccess = () => ({
  type: actionTypes.CREATE_PAIYA_GIFT_CONFIG_SUCCESS,
});

export const createPaiyaGiftCsvFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_PAIYA_GIFT_CONFIG_FAIL,
  error,
});

// Init, success, failure state for create paiya mov & game status
export const createPaiyaMovGameStatusInit = () => ({
  type: actionTypes.CREATE_PAIYA_MOV_STATUS_CONFIG_INIT,
});

export const createPaiyaMovGameStatusSuccess = () => ({
  type: actionTypes.CREATE_PAIYA_MOV_STATUS_CONFIG_SUCCESS,
});

export const createPaiyaMovGameStatusFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_PAIYA_MOV_STATUS_CONFIG_FAIL,
  error,
});

// Init, success, failure state for get paiya config
export const getPaiyaConfigInit = () => ({
  type: actionTypes.GET_PAIYA_CONFIG_INIT,
});

export const getPaiyaConfigSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_PAIYA_CONFIG_SUCCESS,
  payload,
});

export const getPaiyaConfigFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_PAIYA_CONFIG_FAIL,
  error,
});

export const fetchPaiyaTypesAction = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(getPaiyaTypesInit());
  return fetchPaiyaTypeApiCall()
    .then((paiyaTypes: any) =>
      dispatch(getPaiyaTypesSuccess(paiyaTypes))
    )
    .catch((e: object | null | string) =>
      dispatch(getPaiyaTypesFail(e))
    );
};

export const fetchPaiyaConfigAction = (
  gameVariantType: string,
  cityId: string,
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(getPaiyaConfigInit());
  return fetchPaiyaConfigApiCall(gameVariantType, cityId)
    .then((paiyaConfig: any) =>
      dispatch(getPaiyaConfigSuccess(paiyaConfig))
    )
    .catch((e: object | null | string) =>
      dispatch(getPaiyaConfigFail(e))
    );
};

export const createPaiyaStoreUploadCsvAction = (
  gameVariantType: string,
  cityId: string,
  payload: FormData,
  url: string
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(createPaiyaStoreCsvInit());
  return createPaiyaStoreCsvApiCall(gameVariantType, cityId, payload, url)
    .then(() => dispatch(createPaiyaStoreCsvSuccess()))
    .catch((e: object | null | string) => {
      dispatch(createPaiyaStoreCsvFail(e))
    }
    );
};

export const createPaiyaGiftUploadCsvAction = (
  gameVariantType: string,
  cityId: string,
  payload: FormData,
  url: string
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(createPaiyaGiftCsvInit());
  return createPaiyaGiftCsvApiCall(gameVariantType, cityId, payload, url)
    .then(() => dispatch(createPaiyaGiftCsvSuccess()))
    .catch((e: object | null | string) =>
      dispatch(createPaiyaGiftCsvFail(e))
    );
};

export const createPaiyaMovGameStatusAction = (
  gameVariantType: string,
  cityId: string,
  payload: IPaiyaMOVGameStatusPayload,
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(createPaiyaMovGameStatusInit());
  return createPaiyaMovGameStatusApiCall(gameVariantType, cityId, payload)
    .then(() => dispatch(createPaiyaMovGameStatusSuccess()))
    .catch((e: object | null | string) =>
      dispatch(createPaiyaMovGameStatusFail(e))
    );
};